<template>
  <el-card class="box-card shipping_card">
    <div class="shipping_info">
      <el-row>
        <el-col :span="12">
          <p class="number_date">
            Перевозка № {{ bid.id }}.
            {{ dateCreate() }}
          </p>
          <p>Название отчета: {{ report.name }}</p>
        </el-col>
        <el-col :span="12" class="shipping_info_right">
          <p v-if="canAction('shipping_stat')" class="weight">
            Погружено: {{ Number(report.info.weight_ttn).toFixed(2) }},
            выгружено: {{ Number(report.info.weight_fact).toFixed(2) }}, недовоз
            {{
              Number(report.info.weight_ttn - report.info.weight_fact).toFixed(
                2,
              )
            }}<br />
            Суммы: перевозка {{ report.info.total_sum }}<br />
            вознаграждение {{ report.info.expediter_sum }}
          </p>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="19" class="shipping-row">
          <div>
            <h2 class="d_h2">{{ loadLocationFilter(bid) }}</h2>
            <p class="ri_p1">{{ bid.load_point.split(',')[0] }}</p>
          </div>
          <div class="sh_dist">
            <img src="@/assets/img/arrow-route.svg" />
            <p class="ri_p2">{{ bid.distance }} км</p>
          </div>
          <div>
            <h2 class="d_h2">{{ findStevedore(bid) }}</h2>
            <p class="ri_p1">{{ bid.unload_point.split(',')[1] }}</p>
          </div>
        </el-col>
        <el-col :span="5">
          <h2 class="distance">
            <img src="@/assets/img/grass.svg" alt="" />
            {{ freightsType }}
          </h2>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="customer-price">
            <el-col :span="5">
              <b>Цена заказчика:</b>
            </el-col>
            <el-col :span="9"> {{ getCustomerPrice() }} руб/кг </el-col>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="load-day-select">
            <el-row type="flex" align="middle">
              <el-col :span="5">
                <b>Дата погрузки:</b>
              </el-col>
              <el-col :span="9">
                {{ getShipmentDate() }}
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="responsesCount">
        <el-col :span="24">
          <div class="load-day-select">
            <el-row type="flex" align="bottom">
              <el-col :span="5">
                <b>Количество авто в отчете:</b>
              </el-col>
              <el-col :span="9">
                {{ responsesCount }}
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import { UPDATE_STATUS_LOAD_DAY } from '@/store/actions/loadDay'
import { mapGetters } from 'vuex'

import * as DateFormats from '@/datas/DateFormats'
import { getDateOfCertainFormat } from '@/helpers/date'

import shippingMixin from '@/mixins/shippingMixin'
import { roundUp } from '@/helpers/functions'

export default {
  name: 'HeaderLoadDay',
  mixins: [shippingMixin],
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    report: {
      type: Object,
      default: () => ({}),
    },
    loadDays: {
      type: Array,
      default: () => [],
    },
    responses: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({ getLibObj: 'libs/getLibObj' }),
    freightsType() {
      return this.getLibObj('freightTypes')[this.bid.freight_id]
    },
    responsesCount() {
      if (Object.keys(this.report).length && this.report.responses_ids) {
        return this.report.responses_ids.length
      }

      return null
    },
  },
  methods: {
    dateCreate() {
      return this.bidDatesText(
        this.bid.created_at,
        'Дата создания',
        DateFormats.shortDateWithoutYear,
      )
    },
    bidDatesText(dateField, description, dateFormat) {
      const formattedDateCreate = getDateOfCertainFormat(dateField, dateFormat)

      return formattedDateCreate ? `${description} ${formattedDateCreate}` : ``
    },
    async handleOpenCloseDay(day) {
      const status = day.status === 1 ? 0 : 1

      await this.$store.dispatch(`loadDay/${UPDATE_STATUS_LOAD_DAY}`, {
        id: day.id,
        status,
      })
    },
    getCustomerPrice() {
      const prices = this.responses.map(res => {
        const { price_from_field_bidder, price_from_storage_bidder } = res
        let price = ''

        if (this.bid.type_code !== 'harvest') {
          price += roundUp(price_from_storage_bidder, 1000)
        }
        if (this.bid.type_code === 'harvest_or_delivery') {
          price += '(Перевозка), '
        }
        if (this.bid.type_code !== 'delivery') {
          price += roundUp(price_from_field_bidder, 1000)
        }
        if (this.bid.type_code === 'harvest_or_delivery') {
          price += '(Уборка)'
        }

        return price
      })

      return [...new Set(prices)].join(', ')
    },
    getShipmentDate() {
      const dates = this.responses.map(
        response =>
          response.date_loaded &&
          getDateOfCertainFormat(
            response.date_loaded,
            DateFormats.shortDateWithoutYear,
          ),
      )

      return [...new Set(dates)].join(', ')
    },
  },
}
</script>
<style lang="sass">
.report
  & p.weight
    line-height: 1.6 !important
    font-size: 14px
</style>
